<template>
  <div class="tabs_content cols r-tabs-panel r-tabs-state-active" style="display:block;width:100%">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'content-root'
}
</script>
